<script lang="ts" setup>
import { type EpcGes, EPC_GES_CLASS_VALUES } from '@@/shared/property/epc-ges';

const props = defineProps<{
  epcGes: EpcGes
}>();

const epcClassValue = computed(() => props.epcGes.epc.class);
const forceTextWhite = computed(() => {
  if (!epcClassValue.value) return false;
  return [`G`].includes(epcClassValue.value);
});

const notRequired = computed(() => props.epcGes.epc.status === `available-not-required`);
const excessive = computed(() => props.epcGes.epc.status === `available-excessive`);

// NOTE: we can safely use dynamic classes here:
// All are safe-listed in tailwind configuration
// • https://tailwindcss.com/docs/content-configuration#safelisting-classes
// • https://tailwindcss.com/docs/content-configuration#dynamic-class-names
</script>

<template>
  <div class="flex flex-col gap-s">
    <p v-text="$t(`property.epc_ges.performance.title`)" />
    <template v-if="notRequired">
      <span
        class="text-sm"
        v-text="$t(`core.common.not_required`)"
      />
    </template>

    <div
      v-else
      class="grid grid-cols gap-s"
    >
      <div class="grid grid-cols gap-s">
        <ul class="flex items-center">
          <li
            v-for="epcClass in EPC_GES_CLASS_VALUES"
            :key="epcClass"
            class="w-10 h-4 first:rounded-l-3xl last:rounded-r-3xl"
            :class="{
              [`bg-epc-${epcClass}`]: true,
              ['border-white border-4 p-xl rounded-3xl grid place-content-center']: epcClassValue === epcClass,
              ['text-white']: forceTextWhite,
            }"
          >
            <span
              v-if="epcClassValue === epcClass"
              class="font-semibold text-2xl"
              v-text="epcClass"
            />
          </li>
        </ul>
        <b
          v-if="excessive"
          class="text-error text-xs font-normal"
          v-text="$t(`property.epc_ges.epc.emission.excessive`)"
        />
      </div>
    </div>
  </div>
</template>
